import { Permission } from '../models/permissions.interface';

export const MESSAGES_PERMISSION = `(
      ${Permission.CanAccessMessaging}
  ||  ${Permission.CanCreateAnnouncement}
)`;

export const NEWSFEED_PERMISSION = `(
      ${Permission.CanAccessNewsfeed}
)`;

export const CHAT_PERMISSION = `(
      ${Permission.CanAccessMessaging}
)`;

export const USER_ACCESS_PERMISSION = `(
  ${Permission.CanAccessAbsenceMonitor}
||  ${Permission.CanAccessSchedulerAndAddEditShifts}
||  ${Permission.CanAccessRealtimeHotelLaborAnalyzer}
||  ${Permission.CanAccessDailyLaborCheckIn}
||  ${Permission.CanAccessHotelRevenueAnalyzer}
||  ${Permission.CanAccessWellnessChecksAndReporting}
||  ${MESSAGES_PERMISSION}
||  ${NEWSFEED_PERMISSION}
)`;

export const TASKS_PERMISSION = `(
      ${Permission.CanAccessAndPickUpTasks}
    )`;
